import React from "react";
import { PerformanceBadge } from "../PerformanceBadge";
import { getBandForScore } from "../../constants/performance-bands";
import type { AwardedSupplier } from "../../types/supplier-performance.types";

const PROFILE_TYPE_NAMES: Record<number, string> = {
	1: "Client",
	2: "Head Contractor",
	3: "Subcontractor",
	4: "Consultant",
};

interface SupplierOverviewProps {
	supplier: AwardedSupplier;
}

export const SupplierOverview: React.FC<SupplierOverviewProps> = ({
	supplier,
}) => {
	const band = getBandForScore(supplier.overall_average_score);
	const profileTypeName = PROFILE_TYPE_NAMES[supplier.profile_type_id] ?? "Unknown";

	return (
		<div
			className="flex items-center gap-6 rounded-lg bg-white p-6"
			data-testid="supplier-overview"
		>
			{supplier.logo_path ? (
				<img
					src={supplier.logo_path}
					alt={`${supplier.company_name} logo`}
					className="max-h-[100px] max-w-[254px] object-contain"
				/>
			) : (
				<div className="flex h-[100px] w-[100px] items-center justify-center bg-gray-200 text-3xl font-bold text-gray-600">
					{supplier.company_name.charAt(0).toUpperCase()}
				</div>
			)}
			<div className="flex-1">
				<h2 className="text-xl font-semibold text-gray-900">
					{supplier.company_name}
				</h2>
				<div className="mt-1 flex items-center gap-3">
					<span className="inline-flex items-center rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-700">
						{profileTypeName}
					</span>
					<span className="text-sm text-gray-500">
						{supplier.engagement_count} engagement
						{supplier.engagement_count !== 1 ? "s" : ""}
					</span>
					<span className="text-sm text-gray-500">
						{supplier.total_ratings_count} rating
						{supplier.total_ratings_count !== 1 ? "s" : ""}
					</span>
				</div>
			</div>
			<div className="text-right">
				<div className="text-sm text-gray-500">Overall Performance</div>
				<div className="mt-1">
					<PerformanceBadge
						score={supplier.overall_average_score}
						band={band}
						size="lg"
					/>
				</div>
			</div>
		</div>
	);
};
